import { Component, OnInit } from '@angular/core';
import { Table } from '../../shared/table/table';
import { OnboradingService } from '../../onboarding/shared/service/onboarding.service';
import { AppIcons } from '../../../core/icons/fa-icons';
import { DynamicFieldConfig } from '../../../core/shared/dynamic-form/form-config.model';
import { PickListService } from '../../../core/shared/services/picklist.service';
import { PKL_GRP } from '../../../core/shared/models/picklist.model';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CraditService } from '../shared/services/cradit.service';
import { Popup } from '../../../core/shared/components/popup/popup';
import {
  TableAction,
  TableColumn,
} from '../../shared/models/table-models';

@Component({
  selector: 'app-cradit-list',
  imports: [Table, CommonModule, Popup, TranslatePipe],
  templateUrl: './cradit-list.html',
  styleUrl: './cradit-list.css',
})
export class CraditList implements OnInit {
  data: any[] = [];

  statusMap: Record<number, string> = {};

columns: TableColumn[] = [
  {
    key: 'crptOnbrdngSeq',
    label: 'CREDIT_LIST.ONBOARDING_ID',
  },
  {
    key: 'nmOfInstitution',
    label: 'DEMOGRAPHIC.INSTITUTION_NAME',
  },
  {
    key: 'ntn',
    label: 'CREDIT_LIST.NTN',
  },
  {
    key: 'cntctPrsnNm',
    label: 'CREDIT_LIST.CONTACT_PERSON',
  },
  {
    key: 'mblNum',
    label: 'CREDIT_LIST.MOBILE',
  },
  {
    key: 'emlAddrss',
    label: 'CREDIT_LIST.EMAIL',
  },
  {
    key: 'licenseNmbr',
    label: 'CREDIT_LIST.LICENSE_NO',
  },
  {
    key: 'pendingWithNm',
    label: 'LEAD_DASHBOARD.ASSIGNED_TO',
  },
  {
    key: 'crtdBy',
    label: 'COMMON.CREATED_BY',
  },
  {
    key: 'stsKey',
    label: 'COMMON.STATUS',
    type: 'map',
    map: this.statusMap,
  },
  {
    key: 'crtdDt',
    label: 'COMMON.CREATED_DATE',
    type: 'date',
  },
];

  fields: DynamicFieldConfig[] = [
    {
      key: 'crptOnbrdngSeq',
      label: 'CREDIT_LIST.ID',
      type: 'text',
    },
    {
      key: 'nmOfInstitution',
      label: 'DEMOGRAPHIC.INSTITUTION_NAME',
      type: 'text',
    },
    {
      key: 'ntn',
      label: 'CREDIT_LIST.NTN',
      type: 'text',
    },
    {
      key: 'cntctPrsnNm',
      label: 'CREDIT_LIST.CONTACT_PERSON',
      type: 'text',
    },
    {
      key: 'mblNum',
      label: 'CREDIT_LIST.MOBILE',
      type: 'text',
    },
    {
      key: 'emlAddrss',
      label: 'CREDIT_LIST.EMAIL',
      type: 'email',
    },
    {
      key: 'licenseNmbr',
      label: 'CREDIT_LIST.LICENSE_NO',
      type: 'text',
    },
  ];

  private readonly editableStatusCodes = [699, 701, 720];

  get isRelationshipOfficer(): boolean {
    return (
      typeof localStorage !== 'undefined' &&
      (localStorage.getItem('user_role') || '').trim().toUpperCase() === 'LNLY_RO'
    );
  }

  private isEditableStatus(status: number | null | undefined): boolean {
    const statusKey = Number(status);
    return !Number.isNaN(statusKey) && this.editableStatusCodes.includes(statusKey);
  }

  actions: TableAction[] = [
    {
      icon: AppIcons.view,
      tooltip: 'COMMON.VIEW',
      class: 'text-blue-600',
      onClick: (row: any) => this.handleView(row),
    },
    {
      icon: AppIcons.edit,
      tooltip: 'COMMON.EDIT',
      class: 'text-indigo-600',
      onClick: (row: any) => this.handleEdit(row),
      visible: (row: any) =>
        this.isRelationshipOfficer && this.isEditableStatus(row?.stsKey),
    },
    {
      icon: AppIcons.delete,
      tooltip: 'COMMON.DELETE',
      class: 'text-red-600',
      onClick: (row: any) => this.handleDelete(row),
      visible: (row: any) =>
        this.isRelationshipOfficer && this.isEditableStatus(row?.stsKey),
    },
  ];

constructor(
  private onboardingService: OnboradingService,
  private creditService: CraditService,
  private pickListService: PickListService,
  private router: Router,
  private toastr: ToastrService,
  private translate: TranslateService,
) {}

  ngOnInit(): void {
    this.loadStatusMap();
    this.loadData();
  }

  private loadStatusMap(): void {
    this.pickListService
      .loadCodesAsync([PKL_GRP.ONBOARDING_STATUS, PKL_GRP.PANDDING_STATUS])
      .subscribe({
        next: () => {
          [PKL_GRP.ONBOARDING_STATUS, PKL_GRP.PANDDING_STATUS].forEach((grpSeq) => {
            this.pickListService.getOptionsSync(grpSeq).forEach((option) => {
              if (!(option.value in this.statusMap)) {
                this.statusMap[option.value] = option.label;
              }
            });
          });
        },
        error: (error: any) => {
          console.error('Unable to load onboarding status picklist:', error);
        },
      });
  }

loadData(): void {
  this.onboardingService.GetOBAprvdList().subscribe({
    next: (response: any) => {
      const rows = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      this.data = rows
        .filter(
          (item: any) =>
            Number(item.delFlg) !== 1,
        )
        .sort(
          (first: any, second: any) =>
            Number(second.crptOnbrdngSeq) -
            Number(first.crptOnbrdngSeq),
        );
    },

    error: (error: any) => {
      console.error(
        'Unable to load approved onboarding list:',
        error,
      );

      this.data = [];
    },
  });
}

 handleView(row: any): void {
  this.navigateToDocumentBuilder(row, { mode: 'view' });
}

handleEdit(row: any): void {
  this.navigateToDocumentBuilder(row);
}

private navigateToDocumentBuilder(row: any, extraQueryParams: Record<string, string> = {}): void {
  const onboardingSeq = Number(row?.crptOnbrdngSeq);
  const creditProposalSeq = Number(row?.crdtPrpslSeq);

  if (onboardingSeq <= 0) {
    console.error('Onboarding sequence is not available');
    return;
  }

  if (creditProposalSeq <= 0) {
    console.error('Credit proposal sequence is not available');
    return;
  }

  // Store immediately in the service
  this.creditService.setCrdtPrpslSeq(creditProposalSeq);

  this.router.navigate(
    ['/document-builder', onboardingSeq],
    {
      queryParams: {
        crdtPrpslSeq: creditProposalSeq,
        institutionName: row?.nmOfInstitution ?? '',
        ...extraQueryParams,
      },
    }
  );
}

  showDeletePopup = false;
  deleteMessage = '';
  private selectedRow: any = null;

  handleDelete(row: any): void {
    this.selectedRow = row;
    this.deleteMessage = this.translate.instant('CREDIT_LIST.DELETE_CONFIRM', { name: row?.nmOfInstitution });
    this.showDeletePopup = true;
  }

  confirmDelete(): void {
    if (!this.selectedRow) return;

    const row = this.selectedRow;
    this.selectedRow = null;

    const payload = {
      crdtPrpslSeq: Number(row.crdtPrpslSeq),
      crptOnbrdngSeq: Number(row.crptOnbrdngSeq),
      stsKey: Number(row.stsKey),
      delFlg: 1,
    };

    this.creditService.saveCrdtPrpsl(payload).subscribe({
      next: (res: any) => {
        if (res?.error) {
          this.toastr.error(res.error);
          return;
        }

        this.toastr.success(this.translate.instant('CREDIT_LIST.DELETED'));
        this.loadData();
      },
      error: () => this.toastr.error(this.translate.instant('CREDIT_LIST.DELETE_FAILED')),
    });
  }

  saveData(formData: any): void {

    // Update API Call
    // this.onboardingService.Update(formData).subscribe(...)
  }
}
